import React, { useEffect, useState } from 'react';

const PrintRevenuesDetail = () => {
    const [report, setReport] = useState(null);

    useEffect(() => {
        const storedReport = localStorage.getItem('print_financial_report');
        if (storedReport) {
            setReport(JSON.parse(storedReport));
        }
        
        const timer = setTimeout(() => {
            window.print();
        }, 800);

        return () => clearTimeout(timer);
    }, []);

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fr-MA', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount || 0);
    };

    if (!report) return <div className="text-center p-10">جاري تحميل البيانات...</div>;

    const formatDate = (dateString) => {
        if (!dateString) return '';
        try {
            return dateString.split('T')[0];
        } catch (e) {
            return dateString;
        }
    };

    const { summary, revenues, academic_year, print_start_date, print_end_date } = report;
    const yearName = academic_year.name.split('-')[0] || academic_year.name;
    
    const treasuryFeedItem = revenues.breakdown.find(r => r.source === 'تغذية الخزينة');
    const treasuryFeedAmount = treasuryFeedItem ? parseFloat(treasuryFeedItem.amount) || 0 : 0;
    
    const rawValidRevenues = revenues.breakdown.filter(r => parseFloat(r.amount) > 0 && r.source !== 'تغذية الخزينة');
    const adjustedPeriodRevenues = rawValidRevenues.reduce((acc, curr) => acc + (parseFloat(curr.amount) || 0), 0);

    const validRevenues = rawValidRevenues.map(r => {
        const amt = parseFloat(r.amount) || 0;
        const pct = adjustedPeriodRevenues > 0 ? ((amt / adjustedPeriodRevenues) * 100).toFixed(2) : '0.00';
        return {
            ...r,
            amount: amt,
            percentage: pct
        };
    });

    const previousBalance = parseFloat(summary?.previous_balance) || 0;
    const adjustedGeneralRevenues = adjustedPeriodRevenues + previousBalance;

    return (
        <div className="print-container">
            <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <img src="/logo.png" alt="Logo" style={{ width: '80px', height: '80px', objectFit: 'contain', display: 'block', margin: '0 auto 10px auto' }} />
                <h2 style={{ margin: '0', fontSize: '22px', fontWeight: 'bold' }}>جمعية تنمية النقل المدرسي</h2>
                <h3 style={{ margin: '5px 0 0', fontSize: '18px', color: '#555' }}>أولاد دحو</h3>
            </div>

            <h1 className="report-title">
                <u>البيان المالي عن حساب الجمعية</u>
            </h1>
            
            <p className="report-subtitle">
                <u>خلال الفترة الممتدة ما بين {print_start_date ? formatDate(print_start_date) : formatDate(academic_year.start_date)} إلى غاية {print_end_date ? formatDate(print_end_date) : formatDate(academic_year.end_date)}</u>
            </p>

            <p className="report-subsubtitle text-center font-bold text-lg mb-4" style={{ fontStyle: 'italic', textDecoration: 'underline' }}>
                تفاصيل المداخيل
            </p>

            <div className="balance-box">
                <span className="balance-label">الرصيد السابق (مرحل)</span>
                <span className="balance-value">{formatCurrency(previousBalance)}</span>
            </div>

            <table className="report-table">
                <thead>
                    <tr>
                        <th style={{ width: '50%' }}>نوع المداخيل</th>
                        <th style={{ width: '25%' }}>المبلغ</th>
                        <th style={{ width: '25%' }}>النسبة %</th>
                    </tr>
                </thead>
                <tbody>
                    {validRevenues.map((revenue, idx) => (
                        <tr key={idx}>
                            <td className="text-right">{revenue.source}</td>
                            <td className="text-center">{formatCurrency(revenue.amount)}</td>
                            <td className="text-center">{revenue.percentage}%</td>
                        </tr>
                    ))}
                    {validRevenues.length === 0 && (
                        <tr>
                            <td colSpan="3" className="text-center" style={{ padding: '20px' }}>لا توجد مداخيل مسجلة</td>
                        </tr>
                    )}
                </tbody>
                <tfoot>
                    <tr>
                        <td className="text-right font-bold">مجموع المداخيل</td>
                        <td className="text-center font-bold" colSpan="2">{formatCurrency(adjustedPeriodRevenues)}</td>
                    </tr>
                </tfoot>
            </table>

            <div className="summary-boxes">
                <table className="box-table">
                    <tbody>
                        <tr>
                            <td className="box-label text-right">مجموع المداخيل العامة (مداخيل الفترة + الرصيد السابق)</td>
                            <td className="box-value text-center">{formatCurrency(adjustedGeneralRevenues)}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <style dangerouslySetInnerHTML={{__html: `
                @import url('https://fonts.googleapis.com/css2?family=Cairo:wght@400;700&display=swap');
                
                body {
                    margin: 0;
                    padding: 0;
                    background: white;
                }

                .print-container {
                    width: 210mm;
                    min-height: 297mm;
                    padding: 20mm;
                    margin: 0 auto;
                    direction: rtl;
                    font-family: 'Cairo', Arial, sans-serif;
                    box-sizing: border-box;
                    color: #000;
                }

                .report-title {
                    text-align: center;
                    font-size: 24px;
                    font-weight: bold;
                    margin-bottom: 20px;
                }

                .report-subtitle {
                    text-align: center;
                    font-size: 16px;
                    margin-bottom: 10px;
                }

                .balance-box {
                    width: 100%;
                    border: 2px solid #000;
                    display: flex;
                    margin-bottom: 20px;
                }

                .balance-label {
                    flex: 1;
                    padding: 8px 15px;
                    font-weight: bold;
                    font-size: 16px;
                    border-left: 2px solid #000;
                }

                .balance-value {
                    width: 200px;
                    padding: 8px 15px;
                    text-align: center;
                    font-size: 16px;
                    font-family: monospace;
                }

                .report-table {
                    width: 100%;
                    border-collapse: collapse;
                    border: 2px solid #000;
                    margin-bottom: 30px;
                }

                .report-table th, .report-table td {
                    border: 1px solid #000;
                    padding: 8px 12px;
                    font-size: 14px;
                }

                .report-table th {
                    text-align: center;
                    font-weight: bold;
                }

                .report-table tfoot td {
                    border-top: 2px solid #000;
                    font-size: 16px;
                }

                .box-table {
                    width: 100%;
                    border-collapse: collapse;
                    border: 2px solid #000;
                }

                .box-table td {
                    border: 1px solid #000;
                    padding: 10px 15px;
                    font-size: 16px;
                    font-weight: bold;
                }

                .text-right { text-align: right !important; }
                .text-center { text-align: center !important; }
                .font-bold { font-weight: bold !important; }

                @media print {
                    @page { margin: 0; size: A4 portrait; }
                    body { background: none; }
                    .print-container { 
                        width: 100%;
                        height: 100%;
                        padding: 15mm; 
                        margin: 0;
                        box-shadow: none;
                    }
                }
            `}} />
        </div>
    );
};

export default PrintRevenuesDetail;
